import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import aboutMeCss from "./AboutMe.module.css";
import face from "../../asset/Image/aboutMe.png";
import { init } from "ityped";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
let isLoading = true;

export default function AboutMe() {
  const textFieldRef = useRef(null);

  const [about, setAbout] = useState([
    {
      name: "",
      position: "",
    },
  ]);

  useEffect(() => {
    RestClient.GetRequest(AppUrl.HomeAbout).then((result) => {
      console.log(result[0].position_1);
      setAbout({
        name: result[0]["name"],
        position: result[0]["position_1"],
      });
    });
    if (textFieldRef.current && isLoading) {
      isLoading = false;

      init(textFieldRef.current, {
        showCursor: false,
        backDelay: 1500,
        backSpeed: 60,
        strings: ["web developer"],
      });
    }
  }, []);

  return (
    <>
      <Container>
        <Fade top>
          <h1 className="serviceMainTitle text-center">About ME</h1>
        </Fade>
        <div className={`${aboutMeCss.bottom}`}></div>
        <Row>
          <Col lg={6} md={6} sm={12} className={`${aboutMeCss.imgContainer}`}>
            <Zoom top>
              <img src={face} alt="" />
            </Zoom>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={12}
            className="text-center d-flex flex-column justify-content-center align-items-center"
          >
            <Zoom left>
              <h2 className={`${aboutMeCss.details}`}>Hi There ,I'm</h2>
              <h2 className={`${aboutMeCss.title}`}>{about.name}</h2>
              <h2 className={`${aboutMeCss.details}`}>
                Work as <span ref={textFieldRef}></span>
              </h2>
            </Zoom>
          </Col>
        </Row>
      </Container>
    </>
  );
}
